<script setup>
import { computed, onMounted, ref } from 'vue'
import { create_child, get_report_options } from '@/services/child'
import { useRouter } from 'vue-router';
import { get_package, get_option } from '@/services/packages';
import { swalError } from '@/helper';
import dayjs from 'dayjs';
import duration from 'dayjs/plugin/duration';
import { parse_child_meta } from '@/helper';

dayjs.extend(duration)
const router = useRouter()
const packageConfig = ref([])

onMounted(async () =>{
  // updated api
  let response = await get_package();
  // await get_races()
  if (response.error){
    swalError('An error occur')
  }else{
    packageConfig.value = response.result
  }
  child.value.reports = packageConfig.value.map(packageObj => ({
    report_type: packageObj.id,
    sample_id: "",
    sample_date: "",
    checked: false,
    show_id: false,
    sample_dateError: true,
    sample_dateErrorText: 'Profiling registration date is needed!',
    error: true,
    errorText: 'Sample ID needed!'
  }))
  await get_job_fields()
  await get_working_positions()
  // await get_parent_info()
})

const state_list = [
  "Johor",
  "Kedah",
  "Kelantan",
  "Melaka",
  "Negeri Sembilan",
  "Pahang",
  "Perak",
  "Perlis",
  "Pulau Pinang",
  "Sabah",
  "Sarawak",
  "Selangor",
  "Terengganu",
  "Wilayah Persekutuan Kuala Lumpur",
  "Wilayah Persekutuan Labuan",
  "Wilayah Persekutuan Putrajaya"
]
const job_fields = ref([])
async function get_job_fields(){
  let response = await get_option('job_fields')
  if (response.error){
    swalError(response.result, true)
    return
  }
  const data = JSON.parse(response.result.data.attributes.config)
  job_fields.value = data.sort((a, b) => a.name.localeCompare(b.name));

  console.log("🚀 ~ get_job_fields ~ job_fields.value:", job_fields.value)
}

const working_positions = ref([])
async function get_working_positions(){
  let response = await get_option('working_positions')
  if (response.error){
    swalError(response.result, true)
    return
  }
  working_positions.value = JSON.parse(response.result.data.attributes.config)
}
// form validation
const errors = ref({})
const meta_errors = ref({})
const formSubmitted = ref(false)
const child = ref({
  name: "",
  age: "",
  gender: "",
  race: "",
  date_of_birth: "",
  card: "",
  weight: "",
  height: "",
  place_of_birth: "",
  father_name: "",
  father_contact: "",
  mother_name: "",
  mother_contact: "",
  meta:{
    father_work: "",
    father_dob: "",
    father_work_position: "",
    mother_work: "",
    mother_dob: "",
    mother_work_position: "",
  },
  reports: []
})
const father_workError = ref(false)
const father_dobError = ref(false)
const mother_workError = ref(false)
const mother_dobError = ref(false)
const father_nameError = ref(false)
const father_contactError = ref(false)
const mother_nameError = ref(false)
const mother_contactError = ref(false)
const nameError = ref(false)
const ageError = ref(false)
const genderError = ref(false)
const cardError = ref(false)
const weightError = ref(false)
const heightError = ref(false)
const place_of_birthError = ref(false)
const raceError = ref(false)
const dobError = ref(false)
const errorExist = ref(false)

const ageListener = computed(() => {
  if (!child.value.date_of_birth) return '';
  let displayAge = ''
  const dob = new Date(child.value.date_of_birth);
  const now = new Date();
  let age = now.getFullYear() - dob.getFullYear();
  const monthDiff = now.getMonth() - dob.getMonth();
  if (monthDiff < 0 || (monthDiff === 0 && now.getDate() < dob.getDate())) {
    age--;
  }
  let month = ''
  if (age == 0){ // if age 0
    let nowJs = dayjs(new Date())
    let dobJs = dayjs(new Date(child.value.date_of_birth))
    let diff = dayjs.duration(nowJs.diff(dobJs))
    month = diff.months()
    age = month/12
    age = Math.round(age * 100) / 100
    switch (age) {
      case 0.08:
        displayAge = '1 month'
        break;
      case 0.17:
        displayAge = '2 month'
        break;
      case 0.25:
        displayAge = '3 month'
        break;
      case 0.33:
        displayAge = '4 month'
        break;
      case 0.42:
        displayAge = '5 month'
        break;
      case 0.50:
        displayAge = '6 month'
        break;
      case 0.58:
        displayAge = '7 month'
        break;
      case 0.67:
        displayAge = '8 month'
        break;
      case 0.75:
        displayAge = '9 month'
        break;
      case 0.83:
        displayAge = '10 month'
        break;
      case 0.92:
        displayAge = '11 month'
        break;
      case 1:
        displayAge = '1'
        break;
      default:
        break;
    }
  }
  child.value.age = age
  if (displayAge == '') return age + ' years old'
  return displayAge
})

function validateForm(){
  formSubmitted.value = true
  errors.value = [];
  meta_errors.value = []
  child.value.reports.forEach( report => {
    if (report.checked && report.sample_id.length == 0){
      errorExist.value = true
      report.error = true
      errors.value.push({sample_id: true})
    }
    if (report.checked && report.sample_id.length !== 0){
      report.error = false;
      errorExist.value = false
    }
    
    if (report.checked && report.sample_date.length == 0){
      errorExist.value = true
      report.sample_dateError = true
      errors.value.push({sample_date: true})
    }
    if (report.checked && report.sample_date.length !== 0){
      report.sample_dateError = false;
      errorExist.value = false
    }
  })

  if (child.value.name.length <= 0) {
    nameError.value = true;
    errors.value.name = 'Name needed!'
    errorExist.value = true
  } else {
    nameError.value = false;
    errorExist.value = false
  }

  if (child.value.meta.father_dob.length <= 0) {
    father_dobError.value = true;
    meta_errors.value.father_dob = 'Father date of birth needed!'
    errorExist.value = true
  } else {
    father_dobError.value = false;
    errorExist.value = false
  }

  if (child.value.meta.father_work.length <= 0) {
    father_workError.value = true;
    meta_errors.value.father_work = 'Father work needed!'
    errorExist.value = true
  } else {
    father_workError.value = false;
    errorExist.value = false
  }

  if (child.value.meta.mother_dob.length <= 0) {
    mother_dobError.value = true;
    meta_errors.value.mother_dob = 'Mother date of birth needed!'
    errorExist.value = true
  } else {
    mother_dobError.value = false;
    errorExist.value = false
  }

  if (child.value.meta.mother_work.length <= 0) {
    mother_workError.value = true;
    meta_errors.value.mother_work = 'Mother work needed!'
    errorExist.value = true
  } else {
    mother_workError.value = false;
    errorExist.value = false
  }

  if (child.value.mother_name.length <= 0) {
    mother_nameError.value = true;
    errors.value.mother_name = 'Mother name needed!'
    errorExist.value = true
  } else {
    mother_nameError.value = false;
    errorExist.value = false
  }
  
  if (String(child.value.mother_contact).length <= 9) {
    mother_contactError.value = true;
    errors.value.mother_contact = 'Valid contact needed!'
    errorExist.value = true
  } else {
    mother_contactError.value = false;
    errorExist.value = false
  }

  if (child.value.father_name.length <= 0) {
    father_nameError.value = true;
    errors.value.father_name = 'Father name needed!'
    errorExist.value = true
  } else {
    father_nameError.value = false;
    errorExist.value = false
  }
  
  if (String(child.value.father_contact).length <= 9) {
    father_contactError.value = true;
    errors.value.father_contact = 'Valid contact needed!'
    errorExist.value = true
  } else {
    father_contactError.value = false;
    errorExist.value = false
  }

  if (String(child.value.father_contact).length >= 9 && String(child.value.mother_contact).length >= 9) {
    if (String(child.value.mother_contact) == String(child.value.father_contact)){
      father_contactError.value = true;
      errors.value.father_contact = 'Contact number should not be similar to the other!'
      errorExist.value = true

      mother_contactError.value = true;
      errors.value.mother_contact = 'Contact number should not be similar to the other!'
      errorExist.value = true
    }
  }

  if (child.value.race.length <= 0) {
    raceError.value = true;
    errors.value.race = 'Race needed!'
    errorExist.value = true
  } else {
    raceError.value = false;
    errorExist.value = false
  }
  
  if (child.value.card.length <= 0) {
    cardError.value = true;
    errors.value.card = 'IC / Passport needed!'
    errorExist.value = true
  } else {
    cardError.value = false;
    errorExist.value = false
  }
  
  if (child.value.place_of_birth.length <= 0) {
    place_of_birthError.value = true;
    errors.value.place_of_birth = 'State of residence needed!'
    errorExist.value = true
  } else {
    place_of_birthError.value = false;
    errorExist.value = false
  }
  
  if (child.value.age <= 0.08) {
    ageError.value = true;
    errors.value.age = 'Age must be more than 2 month!'
    errorExist.value = true
  } else if (child.value.age == undefined) {
    ageError.value = true;
    errors.value.age = 'Age needed!'
    errorExist.value = true
  } else {
    ageError.value = false;
    errorExist.value = false
  }
  
  if (child.value.weight <= 0) {
    weightError.value = true;
    errors.value.weight = 'Weight not logical'
    errorExist.value = true
  } else if (child.value.weight == undefined) {
    weightError.value = true;
    errors.value.weight = 'Weight needed!'
    errorExist.value = true
  } else {
    weightError.value = false;
    errorExist.value = false
  }
  
  if (child.value.height <= 0) {
    heightError.value = true;
    errors.value.height = 'Height not logical'
    errorExist.value = true
  } else if (child.value.height == undefined) {
    heightError.value = true;
    errors.value.height = 'Height needed!'
    errorExist.value = true
  } else {
    heightError.value = false;
    errorExist.value = false
  }
  
  if (child.value.gender.length <= 0) {
    genderError.value = true;
    errors.value.gender = 'Please select a gender!'
    errorExist.value = true
  } else {
    genderError.value = false;
    errorExist.value = false
  }

  if (child.value.date_of_birth === "") {
    dobError.value = true;
    errors.value.date_of_birth = 'Dirth of Birth is needed!'
    errorExist.value = true
  } else {
    dobError.value = false;
    errorExist.value = false
  }

  // console.log("🚀 ~ validateForm ~ child.value:", child.value)
  if(isObjEmpty(errors.value)){
    submitReport()
  }
}

function isObjEmpty (obj) {
    return Object.keys(obj).length === 0;
}

const loading = ref(false)
async function submitReport(){
  loading.value = true
  child.value['temp_meta'] = parse_child_meta(child.value.meta)
  let response = await create_child(child.value)
  loading.value = false
  // let response = {error: false}
  if (response.error){
    swalError(response.result.error, false)
  }else{
    Swal.fire({
      title: 'Submitted',
      text: 'Your report will be processed within 7 days working days',
      icon: 'success',
      confirmButtonText: 'Continue Subscription',
      denyButtonText: `View Application`,
      denyButtonColor: '#cccccc',
      showDenyButton: true,
      reverseButtons: true,
      allowEscapeKey: false,
      allowOutsideClick: false
    }).then((result) => {
      if (result.isConfirmed) {
        router.push({name: 'subscription'})
      } else if (result.isDenied) {
        router.push({name: 'dna-report-application'})
      }
    })
  }
}
</script>

<template>
  <div class="container-fluid">
    <Breadcrumbs main="Child Registration"/>

    <form class="row" novalidate="" @submit.prevent="validateForm()">
      <div class="col-md-12">
        <div class="card height-equal">
          <div class="card-header">
            <div class="header-top">
              <h5 class="m-0">Child Information</h5>
            </div>
          </div>

          <div class="card-body upload-card">
            <!-- Full Name -->
            <div class="row">
              <div class="col">
                <div class="mb-3">
                  <label class="form-label" for="name">Full Name</label>
                  <input class="form-control" id="name" type="text"
                    v-bind:class="formSubmitted ? nameError ? 'is-invalid' : 'is-valid' : ''" 
                    placeholder="Ali bin Abu"
                    required
                    v-model="child.name"
                  >
                  <div class="form-text">
                    Full name as in IC
                  </div>
                  <div class="invalid-feedback" v-if="errors.name">{{ errors.name }}</div>
                  <!-- <div class="valid-feedback" v-else>Looks good!</div> -->
                </div>
              </div>
            </div>

            <!-- Weight / Height / Date of Birth  -->
            <div class="row">
              <div class="col-md-4">
                <div class="mb-3">
                  <label class="form-label" for="weight">Weight (kg)</label>
                  <input class="form-control" id="weight" type="number"
                    v-bind:class="formSubmitted ? weightError ? 'is-invalid' : 'is-valid' : ''" 
                    placeholder="20"
                    required
                    v-model="child.weight"
                  >
                  <div class="invalid-feedback" v-if="errors.weight">{{ errors.weight }}</div>
                  <!-- <div class="valid-feedback" v-else>Looks good!</div> -->
                </div>
              </div>
              <div class="col-md-4">
                <div class="mb-3">
                  <label class="form-label" for="height">Height (cm)</label>
                  <input class="form-control" id="height" type="number"
                    v-bind:class="formSubmitted ? heightError ? 'is-invalid' : 'is-valid' : ''" 
                    placeholder="20"
                    required
                    v-model="child.height"
                  >
                  <div class="invalid-feedback" v-if="errors.height">{{ errors.height }}</div>
                  <!-- <div class="valid-feedback" v-else>Looks good!</div> -->
                </div>
              </div>
              <div class="col-md-4">
                <div class="mb-3">
                  <label class="form-label">Date of birth</label>
                  <div class="col-sm-9">
                    <input 
                      class="form-control digits" 
                      type="date" 
                      placeholder="2018-01-01"
                      v-model="child.date_of_birth"
                      :class="formSubmitted ? dobError ? 'is-invalid' : 'is-valid' : ''"
                    >
                    <div class="invalid-feedback" v-if="errors.date_of_birth">{{ errors.date_of_birth }}</div>
                    <!-- <div class="valid-feedback" v-else>Looks good!</div> -->
                  </div>
                </div>
              </div>
            </div>

            <!-- Age / Race / Gender -->
            <div class="row">
              <div class="col-md-4">
                <div class="mb-3">
                  <label class="form-label" for="age">Age</label>
                  <input class="form-control" id="age" type="text"
                    v-bind:class="formSubmitted ? ageError ? 'is-invalid' : 'is-valid' : ''" 
                    placeholder="2 months"
                    required
                    :value="ageListener"
                    disabled
                  >
                  <div class="form-text">
                    Child need to be at least 2 months old
                  </div>
                  <div class="invalid-feedback" v-if="errors.age">{{ errors.age }}</div>
                  <!-- <div class="valid-feedback" v-else>Looks good!</div> -->
                </div>
              </div>
              <div class="col-md-4">
                <div class="mb-3">
                  <label class="form-label" for="age">Race</label>
                  <input class="form-control" id="age" type="text"
                    v-bind:class="formSubmitted ? raceError ? 'is-invalid' : 'is-valid' : ''" 
                    placeholder="Malays"
                    required
                    v-model="child.race"
                  >
                  <div class="invalid-feedback" v-if="errors.race">{{ errors.race }}</div>
                  <!-- <div class="valid-feedback" v-else>Looks good!</div> -->
                </div>
              </div>
              <div class="col-md-4">
                <label class="form-label">Gender</label>
                <div class="col-sm-9">
                  <select class="form-select" id="gender"
                    v-bind:class="formSubmitted ? genderError ? 'is-invalid' : 'is-valid' : ''" 
                    v-model="child.gender"
                    required
                  >
                    <option selected disabled value="">Select a gender</option>
                    <option value="male">Male</option>
                    <option value="female">Female</option>
                  </select>
                  <div class="invalid-feedback" v-if="errors.gender">{{ errors.gender }}</div>
                  <!-- <div class="valid-feedback" v-else>Looks good!</div> -->
                </div>
              </div>
            </div>
            
            <!-- MyKad / Place of Birth -->
            <div class="row">
              <div class="col-md-4">
                <div class="mb-3">
                  <label class="form-label" for="card">MyKad/Passport</label>
                  <input class="form-control" id="card" type="text"
                    v-bind:class="formSubmitted ? cardError ? 'is-invalid' : 'is-valid' : ''" 
                    placeholder="000000"
                    required
                    v-model="child.card"
                  >
                  <div class="invalid-feedback" v-if="errors.card">{{ errors.card }}</div>
                  <!-- <div class="valid-feedback" v-else>Looks good!</div> -->
                </div>
              </div>
              <div class="col-md-4">
                <div class="mb-3">
                  <label class="form-label" for="place_of_birth">State of Residence</label>
                  <select class="form-select" name="place_of_birth"
                    v-bind:class="formSubmitted ? place_of_birthError ? 'is-invalid' : 'is-valid' : ''" 
                    required
                    v-model="child.place_of_birth"
                  >
                    <option value="" disabled>State of Residence</option>
                    <option v-for="state in state_list" :key="state" :value="state">
                      {{ state }}
                    </option>
                  </select>
                  <div class="invalid-feedback" v-if="errors.place_of_birth">{{ errors.place_of_birth }}</div>
                  <!-- <div class="valid-feedback" v-else>Looks good!</div> -->
                </div>
              </div>
            </div>

            <!-- Report Type -->
            <div class="row">
              <div class="col mb-3">
                <div class="mb-3">
                  <label class="col-sm-3 col-form-label">Report Type</label>
                  <div class="form-text">
                    Check and fill the form based on the package you have.
                  </div>
                </div>
                <div class="col-md-12">
                  <div class="mega-inline animate-chk">
                    <div class="row w-100">
                      <template v-for="(report, i) in packageConfig">
                        <div class="col-md-4">
                          <div class="card">
                            <div class="d-flex p-20">
                              <div class="ps-0 form-check me-2">
                                <label class="d-block" for="chk-ani">
                                  <input class="checkbox_animated" id="chk-ani" 
                                    type="checkbox"
                                    v-model="child.reports[i].checked"
                                  >
                                </label>
                              </div>
                              <div v-auto-animate class="flex-grow-1">
                                <h6 class="mt-0 mega-title-badge mb-0 ">
                                  {{ report.options.name.value }}
                                </h6>
                                <p class="text-secondary">{{ report.options.description.value }}</p>
                                <div v-if="child.reports[i].checked" class="row me-2">
                                  <div>
                                    <label class="form-label">{{ report.options.sample_text.value }}</label>
                                    <input class="form-control" type="text"
                                      placeholder="123456789"
                                      :class="formSubmitted ? child.reports[i].error ? 'is-invalid' : 'is-valid' : ''" 
                                      v-model="child.reports[i].sample_id"
                                      required
                                    >
                                    <div class="invalid-feedback" v-if="child.reports[i].error">{{ child.reports[i].errorText }}</div>
                                    <!-- <div class="valid-feedback" v-else>Looks good!</div> -->
                                  </div>
                                  
                                  <div class="mt-3">
                                    <label class="form-label">Report Received Date</label>
                                    <input class="form-control" type="date"
                                      placeholder="123456789"
                                      :class="formSubmitted ? child.reports[i].sample_dateError ? 'is-invalid' : 'is-valid' : ''" 
                                      v-model="child.reports[i].sample_date"
                                      required
                                    >
                                    <div class="invalid-feedback" v-if="child.reports[i].error">{{ child.reports[i].sample_dateErrorText }}</div>
                                    <!-- <div class="valid-feedback" v-else>Looks good!</div> -->
                                  </div>
                                  
                                  <div class="mt-3" v-auto-animate>
                                    <p class="mb-2" v-if="child.reports[i].show_id">
                                      Trial ID : 
                                      <span>{{ report.options.trial_id.value }}</span>
                                    </p>
                                    <button @click="child.reports[i].show_id = !child.reports[i].show_id"  type="button" class="btn btn-primary">
                                      Request Trial ID
                                    </button>
                                    <br>
                                    <small>This is only for Trial Package</small>
                                  </div>
                                  
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </template>
                    </div>
                  </div>
                </div>
              </div>
            </div>

          </div>
        </div>

        <!-- Parent Information -->
        <div class="card height-equal">
          <div class="card-header">
            <div class="header-top">
              <h5 class="m-0">Parent Information</h5>
            </div>
          </div>
          <div class="card-body">
            <h6>Father Information</h6>
            <div class="card shadow-none border">
              <div class="card-body">
                <div class="row">
                  <div class="col-md-8">
                    <div class="mb-3">
                      <label class="form-label" for="father_name">Father Name</label>
                      <input class="form-control" id="father_name" type="text"
                        v-bind:class="formSubmitted ? father_nameError ? 'is-invalid' : 'is-valid' : ''" 
                        placeholder="Ali bin Abu"
                        required
                        v-model="child.father_name"
                      >
                      <div class="form-text">
                        Full name as in IC
                      </div>
                      <div class="invalid-feedback" v-if="errors.father_name">{{ errors.father_name }}</div>
                      <!-- <div class="valid-feedback" v-else>Looks good!</div> -->
                    </div>
                  </div>
                  <div class="col-md-4">
                    <div class="mb-3">
                      <label class="form-label" for="father_contact">Father Contact</label>
                      <input class="form-control" id="father_contact" type="tel"
                        v-bind:class="formSubmitted ? father_contactError ? 'is-invalid' : 'is-valid' : ''" 
                        placeholder="012-3456789"
                        required
                        v-model="child.father_contact"
                      >
                      <div class="invalid-feedback" v-if="errors.father_contact">{{ errors.father_contact }}</div>
                      <!-- <div class="valid-feedback" v-else>Looks good!</div> -->
                    </div>
                  </div>
                </div>
                <div class="row">
                  <div class="col-md-4">
                    <div class="mb-3">
                      <label class="form-label" for="mother_work">Working Field</label>
                      <select class="form-select" id="job_field"
                        v-bind:class="formSubmitted ? father_workError ? 'is-invalid' : 'is-valid' : ''" 
                        v-model="child.meta.father_work"
                        required
                      >
                        <option selected disabled value="">Select a field</option>
                        <option v-for="i in job_fields" :value="i.slug">{{ i.name }}</option>
                      </select>
                      <div class="invalid-feedback" v-if="errors.mother_work">{{ errors.mother_work }}</div>
                    </div>
                  </div>
                  <div class="col-md-4">
                    <div class="mb-3">
                      <label class="form-label" for="father_work">Level of Position</label>
                      <select class="form-select" id="father_work_position"
                        v-bind:class="formSubmitted ? father_workError ? 'is-invalid' : 'is-valid' : ''" 
                        v-model="child.meta.father_work_position"
                        required
                      >
                        <option selected disabled value="">Select a position</option>
                        <option v-for="i in working_positions" :value="i.slug">{{ i.name }}</option>
                      </select>

                      <div class="invalid-feedback" v-if="errors.father_work">{{ errors.father_work }}</div>
                    </div>
                  </div>
                  <div class="col-md-4">
                    <div class="mb-3">
                      <label class="form-label" for="father_dob">Date of Birth</label>
                      <input class="form-control digits" id="father_dob"
                        v-bind:class="formSubmitted ? father_dobError ? 'is-invalid' : 'is-valid' : ''" 
                        placeholder="2018-01-01"
                        type="date" 
                        required
                        v-model="child.meta.father_dob"
                      >
                      <div class="invalid-feedback" v-if="errors.father_dob">{{ errors.father_dob }}</div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <h6>Mother Information</h6>
            <div class="card shadow-none border">
              <div class="card-body">
                <div class="row">
                  <div class="col-md-8">
                    <div class="mb-3">
                      <label class="form-label" for="mother_name">Mother Name</label>
                      <input class="form-control" id="mother_name" type="text"
                        v-bind:class="formSubmitted ? mother_nameError ? 'is-invalid' : 'is-valid' : ''" 
                        placeholder="Ali bin Abu"
                        required
                        v-model="child.mother_name"
                      >
                      <div class="form-text">
                        Full name as in IC
                      </div>
                      <div class="invalid-feedback" v-if="errors.mother_name">{{ errors.mother_name }}</div>
                      <!-- <div class="valid-feedback" v-else>Looks good!</div> -->
                    </div>
                  </div>
                  <div class="col-md-4">
                    <div class="mb-3">
                      <label class="form-label" for="mother_contact">Mother Contact</label>
                      <input class="form-control" id="mother_contact" type="tel"
                        v-bind:class="formSubmitted ? mother_contactError ? 'is-invalid' : 'is-valid' : ''" 
                        placeholder="012-3456789"
                        required
                        v-model="child.mother_contact"
                      >
                      <div class="invalid-feedback" v-if="errors.mother_contact">{{ errors.mother_contact }}</div>
                      <!-- <div class="valid-feedback" v-else>Looks good!</div> -->
                    </div>
                  </div>
                </div>
                <div class="row">
                  <div class="col-md-4">
                    <div class="mb-3">
                      <label class="form-label" for="mother_work">Working Field</label>
                      <select class="form-select" id="job_field"
                        v-bind:class="formSubmitted ? mother_workError ? 'is-invalid' : 'is-valid' : ''" 
                        v-model="child.meta.mother_work"
                        required
                      >
                        <option selected disabled value="">Select a field</option>
                        <option v-for="i in job_fields" :value="i.slug">{{ i.name }}</option>
                      </select>
                      <div class="invalid-feedback" v-if="errors.mother_work">{{ errors.mother_work }}</div>
                    </div>
                  </div>
                  <div class="col-md-4">
                    <div class="mb-3">
                      <label class="form-label" for="mother_work">Level of Position</label>
                      <select class="form-select" id="mother_work_position"
                        v-bind:class="formSubmitted ? mother_workError ? 'is-invalid' : 'is-valid' : ''" 
                        v-model="child.meta.mother_work_position"
                        required
                      >
                        <option selected disabled value="">Select a position</option>
                        <option v-for="i in working_positions" :value="i.slug">{{ i.name }}</option>
                      </select>
                      <div class="invalid-feedback" v-if="errors.mother_work">{{ errors.mother_work }}</div>
                    </div>
                  </div>
                  <div class="col-md-4">
                    <div class="mb-3">
                      <label class="form-label" for="mother_dob">Date of Birth</label>
                      <input class="form-control digits" id="mother_dob"
                        v-bind:class="formSubmitted ? mother_dobError ? 'is-invalid' : 'is-valid' : ''" 
                        placeholder="2018-01-01"
                        type="date" 
                        required
                        v-model="child.meta.mother_dob"
                      >
                      <div class="invalid-feedback" v-if="errors.mother_dob">{{ errors.mother_dob }}</div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div class="row">
              <div class="col">
                <button type="submit" class="btn btn-primary float-end mt-3">
                  <span v-if="!loading">Submit</span>
                  <span v-else>
                    <div class="spinner-border spinner-border-sm" role="status">
                      <span class="visually-hidden">Loading...</span>
                    </div>
                  </span>
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </form>
  </div>
</template>

<style scoped>
.checkbox_animated:after {
  border: 2px solid #c7c7c7;
  border-radius: 0.25rem;
}
</style>